import { h } from 'preact'
import { UserData } from '../Event/EventAttendees'
import UserAvatar from '../User/UserAvatar'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  members: UserData[]
}

const GroupMembers = ({ members }: Props) => (
  <div className='widget group-details_description'>
    <div className='group-content-container'>
      <h3 className='widget-title'><Phrase p='Members' /></h3>
      <div style='display: flex; flex-wrap: wrap'>
        {
          members.map(member => <UserAvatar
            key={member.id}
            user={member}
            extraClass='thread-list-avatar avatar--responsive'
            showRank
                                />)
        }
      </div>
    </div>
  </div>
)

export default GroupMembers
